import type { IActivity } from "@/api/Activities";
import { isEmployeePerformed } from "@medoma/models/activities";
import { machineFormat } from "@medoma/models/date-and-time";

const getBasePlanData = (activities: IActivity[]) => {
  return activities.map((activity) => {
    const { id, category, title, schedule } = activity;

    const startDate =
      "start" in schedule
        ? machineFormat(schedule.start, "yyyy-MM-dd")
        : schedule.date;
    const startTimes = "times" in schedule ? schedule.times : schedule.time;
    const requiredCompetences = isEmployeePerformed(activity)
      ? activity.requiredCompetences
      : undefined;
    const endDate =
      "interval" in schedule || "days" in schedule ? schedule.end : undefined;

    return {
      id,
      category,
      title,
      startDate,
      startTimes,
      schedule, // Render <Frequency /> component from 'pages/commandcenter/Patients/Patient/Activities/ActivityOccurrence/ActivitySchedule.tsx' - requires `schedule` as prop
      requiredCompetences,
      endDate,
    };
  });
};

export { getBasePlanData };
